import React from "react";
import "./WorkTogether.css";
const WorkTogether = () => {
  return (
    <>
      <div className="WT---Flex-center">
        <div className="WT---blackbar"></div>
        <div>
          <h1>Let’s Work Together</h1>
          <p>
            Driving your business forward with strong marketing strategies{" "}
            <br />
            Get a free consultation to make this happen!
          </p>
          <button>Connect</button>
        </div>
      </div>
    </>
  );
};

export default WorkTogether;
